
import React from 'react';
import { formatDuration } from '@/utils/timeUtils';

interface RecipeMetadataProps {
  prepTime?: string;
  cookTime?: string;
  servings?: string;
}

const RecipeMetadata: React.FC<RecipeMetadataProps> = ({ prepTime, cookTime, servings }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 bg-muted p-4 rounded-lg">
      <div className="text-center">
        <p className="font-medium">Prep Time</p>
        <p>{formatDuration(prepTime, true)}</p>
      </div>
      
      <div className="text-center">
        <p className="font-medium">Cook Time</p>
        <p>{formatDuration(cookTime, true)}</p>
      </div>
      
      {servings && (
        <div className="text-center">
          <p className="font-medium">Servings</p>
          <p>{servings}</p>
        </div>
      )}
    </div>
  );
};

export default RecipeMetadata;
